<template>
	<div class="avatar">
		<img v-show="isUnreadMessageIconShow" :src="balloonIconPath" :style="balloonStyle"/>
		<img :src="image" :style="style" @click="onClick" />
	</div>
</template>

<script>

export default {
	name: 'Avatar',
	props: {
		image: {
			type: String,
			default: '',
		},
		width: {
			type: Number,
			default: 90,
		},
		clickable: {
			type: Boolean,
			default: true,
		},
		isTeam: {
			type: Boolean,
			default: false,
		},
		isMember: {
			type: Boolean,
			default: false,
		},
		unreadMessageCount: {
			type: Number,
			default: 0,
		},
		isOutLine: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		style: function() {
			let outLine = this.isOutLine ? 2 : 0;
			let style = {
				'width': this.width + outLine + 'px',
				'border-radius': (!this.isTeam || this.isMember) ? '50%' : '0',
				'cursor': this.clickable ? 'pointer': 'default',
				'margin': '0 auto',
			};

			if (this.isOutLine) {
				style.border = `#fff solid ${outLine}px`;
			}

			return style;
		},
		balloonStyle: function() {
			return {
				'position': 'absolute',
			};
		},
		balloonIconPath: function() {
			return require('@/assets/icons/balloon_red.svg');
		},
		isUnreadMessageIconShow: function() {
			return (this.unreadMessageCount > 0);
		}
	},
	methods: {
		onClick: function() {
			if (!this.clickable) {
				return;
			}
			this.$emit('click');
		},
	},
}
</script>

<style lang="scss">

</style>
